/**
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the Commercial License found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _region = _interopRequireDefault(require("@inovua/reactdatagrid-community/packages/region"));

var _ColumnLayout = _interopRequireDefault(require("@inovua/reactdatagrid-community/Layout/ColumnLayout"));

var _DragRow = _interopRequireDefault(require("./plugins/row-reorder/DragRow"));

var _DragRowArrow = _interopRequireDefault(require("./plugins/row-reorder/DragRowArrow"));

var _ScrollingRegion = _interopRequireDefault(require("./plugins/row-reorder/ScrollingRegion"));

var _getRangesForRows = _interopRequireDefault(require("@inovua/reactdatagrid-community/Layout/ColumnLayout/getRangesForRows"));

var _setupRowDrag = _interopRequireDefault(require("./plugins/row-reorder/setupRowDrag"));

var _getDropRowIndex2 = _interopRequireDefault(require("@inovua/reactdatagrid-community/Layout/ColumnLayout/getDropRowIndex"));

var _moveXBeforeY = _interopRequireDefault(require("@inovua/reactdatagrid-community/utils/moveXBeforeY"));

var _dropIndexValidation = _interopRequireDefault(require("@inovua/reactdatagrid-community/Layout/ColumnLayout/dropIndexValidation"));

var _LockedRows = _interopRequireDefault(require("./plugins/locked-rows/LockedRows"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var DRAG_INFO = null;
var scrolling = false;
var SCROLL_MARGIN = 40;
var DRAG_ROW_MAX_HEIGHT = 100;
var raf = global.requestAnimationFrame;

var InovuaDataGridEnterpriseColumnLayout = function (_InovuaDataGridColumn) {
  (0, _inherits2.default)(InovuaDataGridEnterpriseColumnLayout, _InovuaDataGridColumn);

  var _super = _createSuper(InovuaDataGridEnterpriseColumnLayout);

  function InovuaDataGridEnterpriseColumnLayout(_props) {
    var _this;

    (0, _classCallCheck2.default)(this, InovuaDataGridEnterpriseColumnLayout);
    _this = _super.call(this, _props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dropIndex", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dragBoxInitialHeight", 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dropRowHeight", 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "validDropPositions", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "scrollTopRegionRef", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "scrollBottomRegionRef", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dragRowArrow", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "refDragRow", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "refDragRowArrow", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dragRow", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "content", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "lastComputedProps", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "gridScrollInterval", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderLockedEndRows", function (computedProps) {
      return _this.renderLockedRows(computedProps.computedLockedEndRows, 'end', computedProps);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderLockedStartRows", function (computedProps) {
      return _this.renderLockedRows(computedProps.computedLockedStartRows, 'start', computedProps);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderLockedRows", function (rows, position, computedProps) {
      if (!rows || !rows.length) {
        return null;
      }

      return _react.default.createElement(_LockedRows.default, {
        key: position,
        rows: rows,
        computedProps: computedProps,
        position: position
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderDragRowArrow", function () {
      var props = _this.lastComputedProps;
      var rowReorderArrowStyle = props.rowReorderArrowStyle;
      return _react.default.createElement(_DragRowArrow.default, {
        ref: _this.refDragRowArrow,
        rowHeight: _this.dropRowHeight,
        rowReorderArrowStyle: rowReorderArrowStyle
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderReorderRowProxy", function (props) {
      return _react.default.createElement(_DragRow.default, {
        ref: _this.refDragRow,
        renderRowReorderProxy: props && props.renderRowReorderProxy
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderScrollingTopRegion", function () {
      return _react.default.createElement(_ScrollingRegion.default, {
        ref: _this.scrollTopRegionRef,
        dir: -1,
        onMouseEnter: function onMouseEnter(event) {
          return _this.onScrollingRegionMouseEnter(event, -1);
        },
        onMouseLeave: _this.onScrollingRegionMouseLeave
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderScrollingBottomRegion", function () {
      return _react.default.createElement(_ScrollingRegion.default, {
        ref: _this.scrollBottomRegionRef,
        dir: 1,
        onMouseEnter: function onMouseEnter(event) {
          return _this.onScrollingRegionMouseEnter(event, 1);
        },
        onMouseLeave: _this.onScrollingRegionMouseLeave
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onScrollingRegionMouseEnter", function (event, dir) {
      event.preventDefault();

      if (DRAG_INFO && DRAG_INFO.dragging) {
        scrolling = true;
        var props = _this.lastComputedProps;
        var rowReorderScrollByAmount = props.rowReorderScrollByAmount,
            rowReorderAutoScrollSpeed = props.rowReorderAutoScrollSpeed;

        if (scrolling && dir) {
          global.clearInterval(_this.gridScrollInterval);
          _this.gridScrollInterval = global.setInterval(function () {
            return _this.startScrolling(rowReorderScrollByAmount, dir);
          }, rowReorderAutoScrollSpeed);
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "startScrolling", function (rowReorderScrollByAmount, dir) {
      var initialScrollTop = _this.getScrollTop();

      var newScrollTop = initialScrollTop + dir * rowReorderScrollByAmount;
      raf(function () {
        _this.setScrollPosition(newScrollTop);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setScrollPosition", function (scrollTop) {
      var scrollTopMax = _this.getScrollTopMax();

      _this.setReorderArrowVisible(false);

      if (scrollTop < 0) {
        scrollTop = 0;
      }

      if (scrollTop > scrollTopMax) {
        scrollTop = scrollTopMax;
      }

      _this.setScrollTop(scrollTop);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onScrollingRegionMouseLeave", function () {
      scrolling = false;

      _this.setReorderArrowVisible(true);

      global.clearInterval(_this.gridScrollInterval);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getDragRowInstance", function (dragIndex) {
      var visibleRows = _this.getContentRows();

      var dragRow = visibleRows.filter(function (row) {
        return row.props.rowIndex === dragIndex;
      })[0];
      return dragRow;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDragRowMouseDownHandle", function (ev, index, cellNode) {
      if (ev.isDefaultPrevented && ev.isDefaultPrevented() || ev.defaultPrevented) {
        return;
      }

      var props = _this.lastComputedProps;
      var onRowReorder = props.onRowReorder,
          rowReorderColumn = props.rowReorderColumn,
          computedPagination = props.computedPagination,
          computedSortInfo = props.computedSortInfo,
          computedFiltered = props.computedFiltered,
          dataSource = props.dataSource,
          data = props.data,
          computedPivot = props.computedPivot,
          computedGroupBy = props.computedGroupBy,
          computedFocused = props.computedFocused,
          computedSetFocused = props.computedSetFocused,
          setActiveIndex = props.setActiveIndex;

      if (!onRowReorder && (typeof onRowReorder !== 'function' || typeof onRowReorder !== 'boolean')) {
        if (!rowReorderColumn) {
          return;
        }
      }

      if ((ev.nativeEvent ? ev.nativeEvent.which === 3 : ev.which === 3) || ev.metaKey || ev.ctrlKey) {
        return;
      }

      if (computedPagination || computedSortInfo || computedFiltered || typeof dataSource === 'function' || computedPivot && computedPivot.length > 0 || computedGroupBy && computedGroupBy.length > 0) {
        if (typeof onRowReorder !== 'function') {
          return;
        }
      }

      var dragIndex = index;
      var dragRow;
      dragRow = data[dragIndex];

      if (!dragRow) {
        ev === null || ev === void 0 ? void 0 : ev.stopPropagation();
        return;
      }

      var contentNode = _this.content.getDOMNode();

      var headerNode = _this.headerLayout ? _this.headerLayout.headerDomNode.current : null;

      var contentRegion = _region.default.from(contentNode);

      var headerRegion = _region.default.from(headerNode);

      var headerHeight = headerRegion.getHeight();
      var node = cellNode && cellNode.current;

      var cellRegion = _region.default.from(node);

      _this.dragRowArrow.setOffset(headerHeight);

      if (!computedFocused) {
        computedSetFocused(true);
      }

      setActiveIndex(index);

      _this.setupDrag(ev, {
        dragIndex: dragIndex,
        contentRegion: contentRegion,
        headerHeight: headerHeight,
        cellRegion: cellRegion
      }, props);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setupDrag", function (event, _ref, props) {
      var dragIndex = _ref.dragIndex,
          contentRegion = _ref.contentRegion,
          headerHeight = _ref.headerHeight,
          cellRegion = _ref.cellRegion;
      var count = props.count,
          rowHeightManager = props.rowHeightManager;

      var initialScrollTop = _this.getScrollTop();

      var rowRanges = (0, _getRangesForRows.default)({
        count: count,
        initialOffset: contentRegion.top,
        rowHeightManager: rowHeightManager,
        initialScrollTop: initialScrollTop
      });

      var dragBox = _this.getDragRowInstance(dragIndex);

      var dragBoxNode = dragBox.domRef ? dragBox.domRef.current : null;
      var dragBoxInitialRegion;

      if (dragBox) {
        dragBoxInitialRegion = _region.default.from(dragBoxNode);
      }

      _this.dragBoxInitialHeight = dragBoxInitialRegion && dragBoxInitialRegion.getHeight();

      if (DRAG_ROW_MAX_HEIGHT && dragBoxInitialRegion && dragBoxInitialRegion.getHeight() > DRAG_ROW_MAX_HEIGHT) {
        dragBoxInitialRegion.setHeight(DRAG_ROW_MAX_HEIGHT);
        dragBoxInitialRegion.shift({
          top: _this.dragBoxInitialHeight / 2 - DRAG_ROW_MAX_HEIGHT / 2
        });
      }

      var dragRowHeight = dragBoxInitialRegion.getHeight();
      var dragProxy = _this.dragRow ? _this.dragRow : undefined;
      dragProxy.setDragIndex(dragIndex);
      dragProxy.setProps(props);
      var dragBoxOffsets = {
        top: contentRegion.top,
        left: contentRegion.left
      };
      var leftBoxOffset = cellRegion.left - dragBoxOffsets.left;

      _this.dragRowArrow.setLeft(leftBoxOffset);

      var dragProxyPosition = {
        top: dragBoxInitialRegion.top - dragBoxOffsets.top,
        left: dragBoxInitialRegion.left - dragBoxOffsets.left
      };

      if (_this.scrollTopRegionRef.current) {
        _this.scrollTopRegionRef.current.setVisible(true);

        var height = _this.headerLayout && _this.headerLayout.headerNode.offsetHeight;

        _this.scrollTopRegionRef.current.setHeight(height);
      }

      if (_this.scrollBottomRegionRef.current) {
        _this.scrollBottomRegionRef.current.setVisible(true);
      }

      dragProxy.setHeight(dragRowHeight);
      dragProxy.setTop(dragProxyPosition.top);
      dragProxy.setLeft(dragProxyPosition.left);
      DRAG_INFO = {
        dragging: true,
        dragIndex: dragIndex,
        rowRanges: rowRanges,
        contentRegion: contentRegion,
        headerHeight: headerHeight,
        dragBoxInitialRegion: dragBoxInitialRegion,
        dragBoxRegion: dragBoxInitialRegion.clone(),
        dragProxy: dragProxy,
        dragBoxOffsets: dragBoxOffsets,
        initialScrollTop: initialScrollTop,
        leftBoxOffset: leftBoxOffset,
        scrollTopMax: _this.getScrollTopMax()
      };

      _this.setReorderArrowAt(dragIndex, rowRanges);

      (0, _setupRowDrag.default)(event, dragBoxInitialRegion, {
        onDrag: function onDrag(event, config) {
          return _this.onRowDrag(event, config, props);
        },
        onDrop: function onDrop(event, config) {
          return _this.onRowDrop(event, config, props);
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onRowDrag", function (event, config, props) {
      if (!DRAG_INFO) {
        return;
      }

      var _DRAG_INFO = DRAG_INFO,
          dragIndex = _DRAG_INFO.dragIndex,
          currentRanges = _DRAG_INFO.rowRanges,
          contentRegion = _DRAG_INFO.contentRegion,
          dragBoxInitialRegion = _DRAG_INFO.dragBoxInitialRegion,
          dragBoxRegion = _DRAG_INFO.dragBoxRegion,
          dragProxy = _DRAG_INFO.dragProxy,
          headerHeight = _DRAG_INFO.headerHeight,
          dragBoxOffsets = _DRAG_INFO.dragBoxOffsets,
          initialScrollTop = _DRAG_INFO.initialScrollTop,
          scrollTopMax = _DRAG_INFO.scrollTopMax,
          leftBoxOffset = _DRAG_INFO.leftBoxOffset;
      var diffTop = config.diff.top;
      var diffLeft = config.diff.left;
      dragBoxRegion.set({
        top: dragBoxInitialRegion.top,
        bottom: dragBoxInitialRegion.bottom,
        left: dragBoxInitialRegion.left,
        right: dragBoxInitialRegion.right
      });
      var rowReorderScrollByAmount = props.rowReorderScrollByAmount,
          isRowReorderValid = props.isRowReorderValid,
          count = props.count,
          rowHeightManager = props.rowHeightManager;

      var scrollTop = _this.getScrollTop();

      var scrollDiff = scrollTop - initialScrollTop;
      var initialDiffTop = diffTop;
      var initialDiffLeft = diffLeft;
      dragBoxRegion.shift({
        top: diffTop,
        left: diffLeft
      });
      diffTop += scrollDiff;
      var minScrollTop = Math.max(contentRegion.top, 0);
      var maxScrollTop = contentRegion.bottom;
      var scrollAjust = 0;
      var dragProxyAjust = 0;

      if (dragBoxInitialRegion.top + initialDiffTop < minScrollTop + SCROLL_MARGIN && initialDiffTop < 0) {
        scrollAjust = -rowReorderScrollByAmount;
      } else if (dragBoxInitialRegion.top + initialDiffTop > maxScrollTop - SCROLL_MARGIN && initialDiffTop > 0) {
        scrollAjust = rowReorderScrollByAmount;
      }

      if (scrollAjust) {
        if (scrollTop + scrollAjust < 0) {
          scrollAjust = -scrollTop;
        }

        if (scrollTop + scrollAjust > scrollTopMax) {
          scrollAjust = scrollTopMax - scrollTop;
        }

        if (scrollAjust) {
          if (!props.rowReorderAutoScroll) {
            _this.setScrollTop(scrollTop + scrollAjust);
          }

          dragProxyAjust = scrollAjust;
        }
      }

      var dragProxyTop = dragBoxInitialRegion.top - dragBoxOffsets.top + initialDiffTop - dragProxyAjust + headerHeight;
      var dragProxyLeft = dragBoxInitialRegion.left - dragBoxOffsets.left + initialDiffLeft + leftBoxOffset;
      dragProxy.setTop(dragProxyTop);
      dragProxy.setLeft(dragProxyLeft);
      dragProxy.setVisible(true);
      var dir = initialDiffTop > 0 ? 1 : -1;

      var mapRange = function mapRange(r) {
        return _objectSpread(_objectSpread({}, r), {}, {
          top: r.top - scrollDiff,
          bottom: r.bottom - scrollDiff
        });
      };

      var compareRanges = currentRanges.map(mapRange);
      var dropIndex = -1;

      var _getDropRowIndex = (0, _getDropRowIndex2.default)({
        rowHeightManager: rowHeightManager,
        dragBoxInitialRegion: dragBoxInitialRegion,
        dragBoxOffsets: dragBoxOffsets,
        initialDiffTop: initialDiffTop,
        scrollTop: scrollTop,
        dragIndex: dragIndex,
        dir: dir
      }),
          newDropIndex = _getDropRowIndex.index;

      if (newDropIndex !== -1) {
        dropIndex = newDropIndex;
      }

      var validDropPositions;

      if (_this.dropIndex !== dropIndex) {
        validDropPositions = (0, _dropIndexValidation.default)({
          count: count,
          dragIndex: dragIndex,
          dropIndex: dropIndex,
          isRowReorderValid: isRowReorderValid
        });
        _this.validDropPositions = validDropPositions;

        _this.dragRowArrow.setValid(_this.validDropPositions[dropIndex]);
      }

      _this.dropIndex = dropIndex;
      var rowHeight = rowHeightManager.getRowHeight(_this.dropIndex);

      _this.dragRowArrow.setHeight(rowHeight);

      if (dragIndex !== dropIndex && dragIndex + 1 !== dropIndex) {
        _this.setReorderArrowAt(dropIndex, compareRanges);
      } else {
        _this.setReorderArrowVisible(false);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onRowDrop", function (event, config, props) {
      var _assertThisInitialize = (0, _assertThisInitialized2.default)(_this),
          dropIndex = _assertThisInitialize.dropIndex;

      var onRowReorder = props.onRowReorder,
          data = props.data,
          setOriginalData = props.setOriginalData,
          setActiveIndex = props.setActiveIndex;

      if (dropIndex === undefined) {
        if (DRAG_INFO) {
          DRAG_INFO.dragProxy.setVisible(false);
        }

        _this.setReorderArrowVisible(false);

        DRAG_INFO = null;
        return;
      }

      var _DRAG_INFO2 = DRAG_INFO,
          dragProxy = _DRAG_INFO2.dragProxy;
      var _DRAG_INFO3 = DRAG_INFO,
          dragIndex = _DRAG_INFO3.dragIndex;
      DRAG_INFO = null;
      global.clearInterval(_this.gridScrollInterval);
      _this.dragBoxInitialHeight = 0;

      _this.setReorderArrowVisible(false);

      dragProxy.setVisible(false);
      setActiveIndex(dropIndex);

      if (_this.scrollTopRegionRef.current) {
        _this.scrollTopRegionRef.current.setVisible(false);
      }

      if (_this.scrollBottomRegionRef.current) {
        _this.scrollBottomRegionRef.current.setVisible(false);
      }

      if (dropIndex === dragIndex || dropIndex === dragIndex + 1) {
        return;
      }

      if (!_this.validDropPositions[dropIndex]) {
        return;
      }

      if (onRowReorder && typeof onRowReorder === 'function') {
        var rowData = data[dragIndex];
        onRowReorder({
          data: rowData,
          dragRowIndex: dragIndex,
          insertRowIndex: dropIndex
        });
        return;
      }

      if (_this.validDropPositions[dropIndex]) {
        var newDataSource = (0, _moveXBeforeY.default)(data, dragIndex, dropIndex);
        setOriginalData(newDataSource);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setReorderArrowAt", function (index, ranges, visible) {
      visible = visible !== undefined ? visible : index !== DRAG_INFO.dragIndex;

      if (!scrolling) {
        _this.setReorderArrowVisible(visible);
      }

      var box = ranges[index];
      var _DRAG_INFO4 = DRAG_INFO,
          contentRegion = _DRAG_INFO4.contentRegion;
      var boxPos;
      var dragRowArrowHeight = _this.dragRowArrow.props.rowReorderArrowStyle ? _this.dragRowArrow.props.rowReorderArrowStyle.height : 3;

      if (!Number.isInteger(dragRowArrowHeight)) {
        dragRowArrowHeight = 3;
      }

      if (index === 0) {
        boxPos = box.top;
      } else if (index === ranges.length) {
        boxPos = ranges[ranges.length - 1].bottom - dragRowArrowHeight;
      } else {
        boxPos = box.top - Math.floor(dragRowArrowHeight / 2);
      }

      var arrowPosition = boxPos - contentRegion.top;
      return _this.setReorderArrowPosition(arrowPosition);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setReorderArrowPosition", function (top) {
      _this.dragRowArrow.setTop(top);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setReorderArrowVisible", function (visible) {
      _this.dragRowArrow.setVisible(visible);
    });

    _this.refDragRow = function (row) {
      _this.dragRow = row;
    };

    _this.refDragRowArrow = function (dragRow) {
      _this.dragRowArrow = dragRow;
    };

    _this.scrollTopRegionRef = (0, _react.createRef)();
    _this.scrollBottomRegionRef = (0, _react.createRef)();
    return _this;
  }

  return InovuaDataGridEnterpriseColumnLayout;
}(_ColumnLayout.default);

exports.default = InovuaDataGridEnterpriseColumnLayout;